<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import ChangeDevices from "@/components/Common/ChangeDevices.vue";
import { computed } from "vue";
import { Toast } from "@/utils";
import ListContainer from "@module-system/ViewModule/ListContainer.vue";

const rtcId = ref("");

const agentStale = ref(false);
const userStale = ref(false);

const userButtonEnabled = computed(() => {
  return !userStale.value && rtcId;
});

const agentButtonEnabled = computed(() => {
  return !agentStale.value && rtcId;
});

function generateRtcId() {
  rtcId.value = undefined;
  axios
    .get("/api/getnewrtcid")
    .then((response) => {
      rtcId.value = response.data;

      userStale.value = false;
      agentStale.value = false;
    })
    .catch((error) => {
      console.log(error);
      alert("Error generating RTC ID" + error.toString());
    });
}

onMounted(() => {
  generateRtcId();
});

function getUrl(querySearchParams, endpoint = "/r") {
  querySearchParams.set("test", true);

  if(querySearchParams.get("user")) {
    querySearchParams.set("hangUpRedirectUrl", window.location.href);
  }
  
  const route = endpoint + "/" + rtcId.value + "?" + querySearchParams.toString();
  return route;
}

function open(route) {
  window.open(route, "_blank");
}
function copy(text) {
  navigator.clipboard.writeText(text).then(
    function () {
      console.log("Copied to clipboard");
    },
    function (err) {
      console.error("Error copying to clipboard", err);
    },
  );
}

function openAgent() {
  const querySearchParams = new URLSearchParams();
  querySearchParams.set("agent", "agent4");
  querySearchParams.set("agentToken", Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));

  open(getUrl(querySearchParams));

  agentStale.value = true;
}

function openUser() {
  const querySearchParams = new URLSearchParams();
  open(getUrl(querySearchParams));
  userStale.value = true;
}

function copyAgent() {
  const querySearchParams = new URLSearchParams();
  querySearchParams.set("agent", "agent4");
  querySearchParams.set("agentToken", Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15));

  var url = getUrl(querySearchParams);
  var fullUrl = window.location.origin + url;
  copy(fullUrl);
  agentStale.value = true;

  Toast.fire({
    icon: "success",
    title: "Copied Agent URL",
  });
}

function copyUser() {
  const querySearchParams = new URLSearchParams();
  var url = getUrl(querySearchParams);
  var fullUrl = window.location.origin + url;
  copy(fullUrl);
  userStale.value = true;

  Toast.fire({
    icon: "success",
    title: "Copied User URL",
  });
}

const self = computed(() => {
  return {
    generateRtcId,
    openAgent,
    openUser,
    copyAgent,
    copyUser,
    getUrl,
    open,
    copy,

    rtcId: rtcId.value,
    userButtonEnabled: userButtonEnabled.value,
    agentButtonEnabled: agentButtonEnabled.value,
    agentStale: agentStale.value,
    userStale: userStale.value,
  };
});
</script>

<template>
  <v-sheet style="height: 100%" class="bg-deep-purple pa-12" rounded>
    <v-card class="mx-auto px-6 py-8" max-width="500">
      <v-card-title class="text-h5">Create Test Call</v-card-title>
      <v-row>
        <v-col cols="12">
          <v-field :label="rtcId">
            <template #append-inner>
              <v-btn variant="tonal" density="compact" color="green" icon @click="generateRtcId">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </template>
          </v-field>
        </v-col>
        <change-devices></change-devices>
        <v-col>
          <v-btn-group style="width: 100%">
            <v-btn @click="openUser()" style="flex-grow: 1" variant="tonal" :disabled="!userButtonEnabled" color="success"
              >Open User</v-btn
            >
            <v-btn
              @click="copyUser()"
              :disabled="!userButtonEnabled"
              color="success"
              variant="elevated"
              icon="mdi-content-copy"></v-btn>
          </v-btn-group>
        </v-col>
        <v-col>
          <ListContainer section-type="test_page_buttons_top" :model-value="self"></ListContainer>
          <v-btn-group style="width: 100%">
            <v-btn @click="openAgent()" style="flex-grow: 1" variant="tonal" :disabled="!agentButtonEnabled" color="info"
              >Open Agent</v-btn
            >
            <v-btn
              @click="copyAgent()"
              :disabled="!agentButtonEnabled"
              color="info"
              variant="elevated"
              icon="mdi-content-copy"></v-btn>
          </v-btn-group>
        </v-col>
        <ListContainer section-type="test_page_buttons_middle" :model-value="self"></ListContainer>
        <v-col cols="12" v-if="!userButtonEnabled && !agentButtonEnabled">
          <v-btn @click="generateRtcId()" block color="primary" variant="elevated">Generate New Call ID</v-btn>
        </v-col>
        <ListContainer section-type="test_page_buttons_bottom" :model-value="self"></ListContainer>
      </v-row>
    </v-card>
  </v-sheet>
</template>
